import { render, staticRenderFns } from "./ReportModal.vue?vue&type=template&id=dc961c38&scoped=true&"
import script from "./ReportModal.vue?vue&type=script&lang=ts&"
export * from "./ReportModal.vue?vue&type=script&lang=ts&"
import style0 from "./ReportModal.vue?vue&type=style&index=0&id=dc961c38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc961c38",
  null
  
)

export default component.exports